export default __webpack_public_path__ + "src/assets/expand.4371613700650af3b039288804475317.svg";